import { paths } from './config/paths.config';
import Game from './class/game';
import Level, { LevelParams } from './class/level';
import Ship, { ShipParams } from './class/element/ship/ship';
import CapitalShip, { CapitalShipParams } from './class/element/ship/capitalShip';
import PatrolOrder from './class/order/patrolOrder';

import { Faction } from './utils/faction';
import * as shipConfig from './config/ships.config';
import LevelSelectorScene from './class/scene/LevelSelectorScene';

window.onload = () => {
  new Game({
    canvasWidth: 1280,
    canvasHeight: 768,
  });  // main game loop

  /* Create level selector for later */
  Game.instance.levelSelector = new LevelSelectorScene({
    width: Game.instance.canvasWidth,
    height: Game.instance.canvasHeight,
    backgroundSpriteParams: {
      src: `${paths.img.backgrounds}/starfield.jpg`,
      width: 512 / 2,
      height: 512 / 2,
    },
    musicsParamsArray: [{
      volume: 0.5,
      src: `${paths.audio.BGMs}/sc/sc-t3-piano.mp3`,
    }]
  }).create();
  Game.instance.levelSelector.music.pause();

  /* Start first level */
  const firstLevel = Game.instance.levelSelector.availableChoices.level;
  firstLevel.onInit = ((level: Level) => {
    /* Player units */
    const playerCapitalShip = new CapitalShip({
      ...shipConfig.turretDestroyer,
      x: level.scene.width / 2,
      y: level.scene.height / 2,
      faction: Faction.PLAYER,
      shieldParams: { radius: 260, HP: 1000 },
      generatorParams: {}, // default generator values
    } as CapitalShipParams).create();
    const playerShips = [
      new Ship({ ...shipConfig.basicJet, x: playerCapitalShip.x - 100, y: playerCapitalShip.y + playerCapitalShip.height, parentShip: playerCapitalShip }).create(),
      new Ship({ ...shipConfig.basicJet, x: playerCapitalShip.x, y: playerCapitalShip.y + playerCapitalShip.height, parentShip: playerCapitalShip, }).create(),
      new Ship({ ...shipConfig.basicJet, x: playerCapitalShip.x + 100, y: playerCapitalShip.y + playerCapitalShip.height, parentShip: playerCapitalShip, }).create(),
    ];
    level.scene?.camera.goToCoords(playerCapitalShip.x, playerCapitalShip.y); // camera focus

    // /* ENEMY warship patrolling */
    // const enemy1 = new Ship({
    //   ...shipConfig.destroyer,
    //   x: 2000,
    //   y: 1000,
    //   faction: Faction.ENEMY,
    //   shieldParams: { radius: 260, HP: 1000 },
    // } as ShipParams).create();
    // enemy1.behaviour.setOrder(new PatrolOrder({
    //   x: 3200,
    //   y: 1000,
    // }));

    /* default ctrlGroups */
    Game.instance.controlSchemes.rts.controlGroups[1].setElementsIds([playerCapitalShip.id]);
    Game.instance.controlSchemes.rts.controlGroups[2].setElementsIds(playerShips.map(s => s.id));
  });
  firstLevel.start();
};
